import { supabase } from '../supabase/client';
import { getAuthenticatedClient } from '../supabase/authenticatedClient';

export const getEvents = async () => {
  // Get yesterday's date at midnight UTC
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  yesterday.setHours(0, 0, 0, 0);

  const { data, error } = await supabase
    .from('events')
    .select(
      `
      *,
      places (
        name,
        address
      ),
      cities (
        name,
        state
      )
    `
    )
    .gte('end_date', yesterday.toISOString())
    .neq('status', 'submitted')
    .neq('status', 'inactive')
    .neq('status', 'disabled')
    .order('start_date');

  if (error) {
    throw error;
  }

  return data;
};

export const allEvents = async () => {
  const { data, error } = await supabase
    .from('events')
    .select(
      `
      *,
      places (
        name,
        address
      ),
      cities (
        name,
        state
      )
    `
    )
    .order('start_date');

  if (error) {
    throw error;
  }

  return data;
};

export const createEvent = async eventData => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client.from('events').insert([eventData]).select().single();

  if (error) {
    throw error;
  }

  return data;
};

export const updateEvent = async (id, eventData) => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client
    .from('events')
    .upsert({ ...eventData, id })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const deleteEvent = async id => {
  const client = await getAuthenticatedClient();
  const { error } = await client.from('events').delete().eq('id', id);

  if (error) {
    throw error;
  }
};
